import React from 'react'
import { useCountryRegionList } from '../../Hooks/useCountryRegionList'
import { AutocompleteInput } from './AutocompleteInput'

interface CountryRegionPickerProps {
  countryCode: string,
  value?: string
  className?: any
  label?: string
  helperText?: string
  onChange: (value: string) => void
  disabled?: boolean
  required?: boolean
  variant?: 'standard' | 'filled' | 'outlined'
  placeholder?: string
  freeSolo?: boolean
  noOptionsText?: string
  clearOnBlur?: boolean
  error?: boolean
}

export const CountryRegionPicker: React.FC<CountryRegionPickerProps> = ({
  countryCode,
  className,
  value,
  label,
  helperText,
  onChange,
  disabled,
  required,
  variant,
  placeholder,
  freeSolo,
  noOptionsText,
  clearOnBlur,
  error,
}) => {
  const entities = useCountryRegionList(countryCode)

  return (
    <AutocompleteInput
      value={value}
      className={className}
      label={label}
      helperText={helperText}
      onChange={value => onChange(value as string)}
      disabled={disabled}
      required={required}
      variant={variant}
      placeholder={placeholder}
      freeSolo={freeSolo}
      options={entities}
      noOptionsText={noOptionsText}
      clearOnBlur={clearOnBlur}
      error={error}
    />
  )
}
